import SvgIcon from './SvgIcon';

const unlock = (props) => ({
  ...props,
  viewBox: '0 0 12 16',
  shapes: [
    {
      type: 'path',
      attrs: {
        d: 'M2.5,7 L11,7 C11.5522847,7 12,7.44771525 12,8 L12,15 C12,15.5522847 11.5522847,16 11,16 L1,16 C0.44771525,16 0,15.5522847 0,15 L0,8 C0,7.44771525 0.44771525,7 1,7 L1,4.98151367 C1,2.23029964 3.23857625,0 6,0 C8.4241995,0 10.4454541,1.71883353 10.9029715,4 L9.34209114,4 C8.9671727,2.54028848 7.9088888,1.5 6,1.5 C3.54860291,1.5 2.5,3.21561511 2.5,5.33193359 L2.5,7 Z',
      },
    },
  ],
});
export default (props) => SvgIcon(unlock(props));
export { unlock };
